import React from 'react';

const imgStyleRight = {
  float: 'right',
  border: '3px solid #dcd4c5',
  height: '186px',
  width: '249px',
  marginLeft: 20,
  marginBottom: 10,
};

function Missionary(props) {
  return (
    <div>
      <h2>Horacio and Sara Brancatelli</h2>
      <h4>in Buenos Aires, Argentina</h4>
      <p><img src='/img/profile/HoracioAndSaraBrancatelli.jpg' alt='Horatio and Sara Brancatelli' style={imgStyleRight} height='205px' width='250px'></img></p>
      <p>
        Horacio and Sara minister in a missionary church plant at Villa Crespo under
        Biblical Ministries Worldwide. Originally begun by the Australian missionaries,
        Daniel and Nelly De la Fuente, Horacio became pastor when the De la Fuente’s retired from the field.
        Horacio is a former police officer, and Sara is the daughter of an American missionary to Argentina.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>

      <h2>Jane and Steve Gibb</h2>
      <h4>Serving the Asia/Pacific with Biblical Ministries Worldwide</h4>
      <p><img src='/img/profile/SteveAndJaneGibb.jpg' alt='Gibb Family' style={imgStyleRight} height='225px' width='300px'></img></p>
      <p>
        Steve and Jane are seasoned missionaries and church planters.
        Since leaving the mission field in Vanuatu, Steve has worked as the Asia/Pacific regional director,
        overseeing the vast family of BMW missionaries in this part of the world, and recruiting
        more missionaries for the field.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>

      <h2>Chris and Fiona Tyrrell</h2>
      <h4>Ministering in Nagishot, South Sudan</h4>
      <p><img src='/img/profile/chris_fiona_P1000740.jpg' alt='Chris and Fiona Tyrrell' style={imgStyleRight}></img></p>
      <p>
        Chris and Fiona serve under the Africa Inland Mission. Their mission assignment began in Rwanda,
        where they worked with the local churches to help them reach the Rwandan people.
        Now they are ministering the gospel in Nagishot, South Sudan, encouraging and building the
        church through their Didinga Focus Team.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>

      <h2>Pastor James and Lourdes Montenegro</h2>
      <p><img src='/img/profile/Pastor_James_Montenegro.jpg' alt='Pastor James Montenegro' style={imgStyleRight}></img></p>
      <p>A graduate of the Asia Baptist Bible College in Manila, Pastor James entered the ministry in 1990, and has been the lead pastor at the Bible Baptist Church in the Bulacan Province of the Philippines since 2002. He and his wife, Lourdes, have four children, and they labour in church ministries such as a youth Bible club, Sunday school, choir, prayer meetings, and home visitation. (Picture below - Filipinos)</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <h2>Pastor Joey Casas</h2>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <h2>Elise Long</h2>
      <p><img src='/img/profile/EliseLong.jpg' alt='Elise Long' style={imgStyleRight}></img></p>
      <p>Elise serves with CrossView in the Province of Palawan, part of the Philippines. Her ministry with the Palawanos includes the maintenance of a community health programme, and training local believers from BK in discipleship, church planting, and evangelism. Elise pursues a holistic approach to ministry by feeding the hungry, tending to the sick, and teaching the Word.</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <h2>Garry and Faith McCay</h2>
      <p><img src='/img/profile/GarryAndFaithMcCay.jpg' alt='Garry and Faith McCay' style={imgStyleRight}></img></p>
      <p>Garry and Faith have served with CrossView (formally New Tribes Mission) in East New Britain, PNG among the Kol people. Their ministry has been to evangelise the people and plant a local church among this group scattered in the mountainous region. Garry has also translated many portions of the Bible as well as New Testament Bible lessons. Part of his focus is to train nationals in literacy and leadership. The ministry also often involves providing the villages with medical assistance.</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </div >
  )
}

export default Missionary;
